import axios from "axios";
import { CONTRACT_HEXADDRESS } from "../../constants/tokens";
import { TRON_HOST } from "../../constants/config";

export class ContractCodeService {
  public fetchContractCode = async (params) => {
    try {
      const { token } = params;

      const queryString = `?value=${CONTRACT_HEXADDRESS[token]}`;
      const { data } = await axios.get(
        `${TRON_HOST}/wallet/getcontract${queryString}`
      );

      const { abi, bytecode } = data;

      return {
        code: {
          abi,
          bytecode,
        },
      };
    } catch (e) {
      console.log(e);
      throw Error(e.message);
    }
  };
}
